// GlobalDueSubscriptionNotifier.js
import { useEffect } from 'react';
import api from '../services/apiService';

const GlobalDueSubscriptionNotifier = () => {
  useEffect(() => {
    // 1) Ohne Token -> gar nichts tun
    const token = sessionStorage.getItem('accessToken');
    if (!token) return;

    // 2) Async-Funktion im Effekt
    const run = async () => {
      try {
        const { data } = await api.get('/subscriptions');
        const today = new Date();

        const dueSubscriptions = (Array.isArray(data) ? data : []).filter((sub) => {
          if (!sub?.nextDueDate) return false;
          const d = new Date(sub.nextDueDate);
          return !isNaN(d) && d <= today;
        });

        if (dueSubscriptions.length > 0) {
          window.alert(`Achtung: Es gibt ${dueSubscriptions.length} fällige Subscription(en)!`);
        }
      } catch (err) {
        const status = err?.response?.status;
        // 3) 401/403 leise ignorieren (passiert z. B. bei abgelaufenem Token)
        if (status === 401 || status === 403) return;
        console.error('Fehler beim Abrufen der Subscriptions:', err);
      }
    };

    run();
  }, []); // keine deps: nur einmal nach Mount (aber nur mit Token siehe oben)

  return null;
};

export default GlobalDueSubscriptionNotifier;
